export const PATIENT_FORM_SAVE_FIELD = "patientForm/PATIENT_FORM_SAVE_FIELD";
export const PATIENT_FORM_SAVE_BIRTH_DATE_FIELD =
  "patientForm/PATIENT_FORM_SAVE_BIRTH_DATE_FIELD";
export const PATIENT_FORM_SAVE_BIRTH_DAY_FIELD =
  "patientForm/PATIENT_FORM_SAVE_BIRTH_DAY_FIELD";
export const PATIENT_FORM_SAVE_BIRTH_MONTH_FIELD =
  "patientForm/PATIENT_FORM_SAVE_BIRTH_MONTH_FIELD";
export const PATIENT_FORM_SAVE_BIRTH_YEAR_FIELD =
  "patientForm/PATIENT_FORM_SAVE_BIRTH_YEAR_FIELD";
export const PATIENT_FORM_SAVE_COUNTRY_FIELD =
  "patientForm/PATIENT_FORM_SAVE_COUNTRY_FIELD";
export const PATIENT_FORM_SAVE_CITY_FIELD =
  "patientForm/PATIENT_FORM_SAVE_CITY_FIELD";
export const PATIENT_FORM_SAVE_DISTRICT_FIELD =
  "patientForm/PATIENT_FORM_SAVE_DISTRICT_FIELD";

export const CREATE_PATIENT_FORM_REQUEST =
  "patientForm/CREATE_PATIENT_FORM_REQUEST";
export const CREATE_PATIENT_FORM_SUCCESS =
  "patientForm/CREATE_PATIENT_FORM_SUCCESS";
export const CREATE_PATIENT_FORM_FAILURE =
  "patientForm/CREATE_PATIENT_FORM_FAIL";
export const CREATE_PATIENT_OVER_MAX = "patientForm/CREATE_PATIENT_OVER_MAX";
export const CREATE_PATIENT_OVER_MAX_CLOSE_MODAL =
  "patientForm/CREATE_PATIENT_OVER_MAX_CLOSE_MODAL";

export const UPDATE_PATIENT_FORM_REQUEST =
  "patientForm/UPDATE_PATIENT_FORM_REQUEST";
export const UPDATE_PATIENT_FORM_SUCCESS =
  "patientForm/UPDATE_PATIENT_FORM_SUCCESS";
export const UPDATE_PATIENT_FORM_FAILURE =
  "patientForm/UPDATE_PATIENT_FORM_FAILURE";

export const DETAIL_PATIENT_FORM_REQUEST =
  "patientForm/DETAIL_PATIENT_FORM_REQUEST";
export const DETAIL_PATIENT_FORM_SUCCESS =
  "patientForm/DETAIL_PATIENT_FORM_SUCCESS";
export const DETAIL_PATIENT_FORM_FAILURE =
  "patientForm/DETAIL_PATIENT_FORM_FAILURE";

export const SET_PATIENT_INFO = "patientForm/SET_PATIENT_INFO";

export const RESET_REDIRECT_PATIENT_FORM = "RESET_REDIRECT_PATIENT_FORM";
export const RESET_PATIENT_FORM = "RESET_PATIENT_FORM";

export const RESET_DEFAULT_COUNTRY = "RESET_DEFAULT_COUNTRY";
export const RESET_DEFAULT_NATION = "RESET_DEFAULT_NATION";

export const URL_PATIENT_INSERT = "/patient/insert";
export const URL_PATIENT_UPDATE = "/patient/update";
export const URL_PATIENT_DETAIL = "/patient/detail";

export const URL_REDIRECT_AFTER_CREATE_PATIENT =
  "/patient/URL_REDIRECT_AFTER_CREATE_PATIENT";

export const CHECK_PATIENT_BEFORE_CREATE =
  "/patient/CHECK_PATIENT_BEFORE_CREATE";

export const GET_INFO_PATIENT_CMND =
  "patient/GET_INFO_PATIENT_CMND";

export const GET_INFO_PATIENT_CMND_CONFIRM_SUCCESS =
  "patient/GET_INFO_PATIENT_CMND_CONFIRM_SUCCESS";

export const GET_INFO_PATIENT_CMND_CONFIRM_CANCEL =
  "patient/GET_INFO_PATIENT_CMND_CONFIRM_CANCEL";

export const GET_INFO_PATIENT_CMND_SUCCESS =
  "patient/GET_INFO_PATIENT_CMND_SUCCESS";

export const GET_INFO_PATIENT_CMND_FAILURE =
  "patient/GET_INFO_PATIENT_CMND_FAILURE";
